import { PlusSquareOutlined } from '@ant-design/icons';
import { Button } from '@imprivata-cloud/components';
import { Dropdown, Flex, Menu } from 'antd';
import { useTranslation } from 'react-i18next';

export interface AuthenticatorUiData {
  text: string;
  icon: React.ReactNode;
  onClick: () => void;
}

const AuthMethodListHeader = ({ authenticatorsList }: { authenticatorsList: Record<string, AuthenticatorUiData> }) => {
  const { t } = useTranslation();
  const authenticators = (
    <Menu>
      {Object.keys(authenticatorsList).map((authenticator) => (
        <Menu.Item key={authenticatorsList[authenticator].text} onClick={authenticatorsList[authenticator].onClick}>
          <Flex gap={10}>
            {authenticatorsList[authenticator].icon}
            {authenticatorsList[authenticator].text}
          </Flex>
        </Menu.Item>
      ))}

      {Object.keys(authenticatorsList).length === 0 && (
        <Menu.Item key="No method" disabled>
          {t('self-service.auth-method.empty')}
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <div className="authenticators-table-title">
      <Flex justify="space-between" align="center">
        <span>{t('self-service.authenticator-list.table-title')}</span>
        <Dropdown
          trigger={['click']}
          dropdownRender={() => authenticators}
          overlayClassName={'user-dropdown-menu'}
          placement={'bottomLeft'}
        >
          <Button
            className="add-another-method-btn"
            type="text"
            label={t('self-service.authenticator-list.add-an-authenticator-btn')}
            icon={<PlusSquareOutlined />}
          />
        </Dropdown>
      </Flex>
    </div>
  );
};

export default AuthMethodListHeader;
